var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalida(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.4,295H20.2c-8.2,0-14.8-6.6-14.8-14.8V19.8C5.4,11.6,12,5,20.2,5h107.2c8.2,0,14.8,6.6,14.8,14.8 s-6.6,14.8-14.8,14.8H35.1v230.6h92.3c8.2,0,14.8,6.6,14.8,14.8C142.2,288.4,135.6,295,127.4,295z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287,132.3c-4.8-4.5-9.5-9-14.3-13.5C258,104.8,243.3,90.9,228.6,77c-6.5-6.1-16.4-5.9-22.3,0.4 c-6,6.4-5.4,16,1.2,22.1c10.7,9.9,21.3,19.7,32,29.6c1.6,1.4,3.1,2.9,5.1,4.8c-1.4,0-2.1,0-2.8,0c-27.9,0-81.5,0-109.4,0 c-1,0-2.1,0-3.1,0.1c-8.4,0.7-14.9,8.9-13.6,17.3c1.2,8,7.4,13.3,15.7,13.3c28.1,0,81.8,0,109.9,0c0.9,0,1.9,0,2.8,0 c0.1,0.3,0.3,0.5,0.4,0.8c-0.5,0.3-1.1,0.5-1.5,0.9c-11.9,11-23.7,21.9-35.6,32.9c-4.4,4.1-6.1,9.1-4.8,15 c2.8,11.9,17.2,15.8,26.3,7.2c19.4-18.3,38.8-36.7,58.2-55.2C297.2,156.5,297.1,141.8,287,132.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalida);
export default __webpack_public_path__ + "static/media/salida.79543e8aa5722de95a873fa730ab3ec5.svg";
export { ForwardRef as ReactComponent };